import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import { AlertTriangle } from 'lucide-react';

interface WidgetErrorBoundaryProps {
  children: React.ReactNode;
  widgetType: string;
  onRefresh?: () => void;
}

const WidgetErrorBoundary: React.FC<WidgetErrorBoundaryProps> = ({ 
  children, 
  widgetType, 
  onRefresh 
}) => {
  const customFallback = (
    <div className="flex flex-col items-center justify-center h-full p-6 bg-white text-center rounded-xl border border-gray-200 shadow-sm">
      <div className="p-3 rounded-full bg-red-50 mb-4">
        <AlertTriangle size={24} className="text-red-600" />
      </div>
      <h3 className="text-lg font-semibold text-black mb-2">Widget Error</h3>
      <p className="text-sm text-gray-600 mb-4">
        The {widgetType} widget encountered an error
      </p>
      {onRefresh && (
        <button
          className="px-4 py-2 bg-[#24c35b] text-white rounded-lg text-sm hover:bg-[#20a855] transition-colors shadow-sm"
          onClick={onRefresh}
        >
          Reload Widget
        </button>
      )}
    </div>
  );

  return (
    <ErrorBoundary fallback={customFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default WidgetErrorBoundary; 